export const LOCATION_LIST_REQUEST = 'LOCATION_LIST_REQUEST';
export const LOCATION_LIST_SUCCESS = 'LOCATION_LIST_SUCCESS';
export const LOCATION_LIST_FAIL = 'LOCATION_LIST_FAIL';

export const LOCATION_LIST_BY_IDS_REQUEST = 'LOCATION_LIST_BY_IDS_REQUEST';
export const LOCATION_LIST_BY_IDS_SUCCESS = 'LOCATION_LIST_BY_IDS_SUCCESS';
export const LOCATION_LIST_BY_IDS_FAIL = 'LOCATION_LIST_BY_IDS_FAIL';

export const LOCATION_DETAILS_REQUEST = 'LOCATION_DETAILS_REQUEST';
export const LOCATION_DETAILS_SUCCESS = 'LOCATION_DETAILS_SUCCESS';
export const LOCATION_DETAILS_FAIL = 'LOCATION_DETAILS_FAIL';

export const LOCATION_CREATE_REQUEST = 'LOCATION_CREATE_REQUEST';
export const LOCATION_CREATE_SUCCESS = 'LOCATION_CREATE_SUCCESS';
export const LOCATION_CREATE_FAIL = 'LOCATION_CREATE_FAIL';

export const LOCATION_UPDATE_REQUEST = 'LOCATION_UPDATE_REQUEST';
export const LOCATION_UPDATE_SUCCESS = 'LOCATION_UPDATE_SUCCESS';
export const LOCATION_UPDATE_FAIL = 'LOCATION_UPDATE_FAIL';

export const LOCATION_DELETE_REQUEST = 'LOCATION_DELETE_REQUEST';
export const LOCATION_DELETE_SUCCESS = 'LOCATION_DELETE_SUCCESS';
export const LOCATION_DELETE_FAIL = 'LOCATION_DELETE_FAIL';

export const LOCATION_DTO_REQUEST = 'LOCATION_DTO_REQUEST';
export const LOCATION_DTO_SUCCESS = 'LOCATION_DTO_SUCCESS';
export const LOCATION_DTO_FAIL = 'LOCATION_DTO_FAIL';

// Custom location-specific actions
export const LOCATION_BY_ORGANISATION_REQUEST = 'LOCATION_BY_ORGANISATION_REQUEST';
export const LOCATION_BY_ORGANISATION_SUCCESS = 'LOCATION_BY_ORGANISATION_SUCCESS';
export const LOCATION_BY_ORGANISATION_FAIL = 'LOCATION_BY_ORGANISATION_FAIL';

export const LOCATION_BY_STATUS_REQUEST = 'LOCATION_BY_STATUS_REQUEST';
export const LOCATION_BY_STATUS_SUCCESS = 'LOCATION_BY_STATUS_SUCCESS';
export const LOCATION_BY_STATUS_FAIL = 'LOCATION_BY_STATUS_FAIL';

export const LOCATION_BY_ODS_CODE_REQUEST = 'LOCATION_BY_ODS_CODE_REQUEST';
export const LOCATION_BY_ODS_CODE_SUCCESS = 'LOCATION_BY_ODS_CODE_SUCCESS';
export const LOCATION_BY_ODS_CODE_FAIL = 'LOCATION_BY_ODS_CODE_FAIL';

export const LOCATION_BY_LOCATION_CODE_REQUEST = 'LOCATION_BY_LOCATION_CODE_REQUEST';
export const LOCATION_BY_LOCATION_CODE_SUCCESS = 'LOCATION_BY_LOCATION_CODE_SUCCESS';
export const LOCATION_BY_LOCATION_CODE_FAIL = 'LOCATION_BY_LOCATION_CODE_FAIL';

export const LOCATION_BY_UPLOAD_BATCH_REQUEST = 'LOCATION_BY_UPLOAD_BATCH_REQUEST';
export const LOCATION_BY_UPLOAD_BATCH_SUCCESS = 'LOCATION_BY_UPLOAD_BATCH_SUCCESS';
export const LOCATION_BY_UPLOAD_BATCH_FAIL = 'LOCATION_BY_UPLOAD_BATCH_FAIL';

export const LOCATION_SUBJECTS_REQUEST = 'LOCATION_SUBJECTS_REQUEST';
export const LOCATION_SUBJECTS_SUCCESS = 'LOCATION_SUBJECTS_SUCCESS';
export const LOCATION_SUBJECTS_FAIL = 'LOCATION_SUBJECTS_FAIL'; 